import { render, staticRenderFns } from "./BottomBackBlock.vue?vue&type=template&id=b4e5a552"
import script from "./BottomBackBlock.vue?vue&type=script&lang=js"
export * from "./BottomBackBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports